import { Action, createAction, props } from '@ngrx/store';
import { Card, CardView, ListQuery } from './models/card.model';
import { MapLayerSummaryByStatus } from '../lsd/models/map-layer-summary.model';
import { Layer, LayerDocuments, LayerDocumentUIdsSet } from '../cop/models';
import { QueryResult } from 'src/app/modules/core/store/models';
import { ExportTemplate } from 'src/app/modules/management/store/datasets/dataset.model';
import { Dataset } from 'src/app/modules/core/store/models/dataset.model';
import { Document, RelatedDocumentsRequest } from 'src/app/modules/core/store/models/document.model';
import { Cluster } from '@googlemaps/markerclusterer';
import { ListsTableType } from './models/table-type.enum';

//
// Cards and tables
//
export const cardClicked = createAction('[COP/Lists] Card Click Event', props<{ layerUId: string; document: Document }>());
export const setCardSearchTermToStore = createAction('[COP/Lists/Store] Set Card Search Term', props<{ searchTerm: string }>());

export const clearListsToStore = createAction('[COP/Lists/Store] Clear Lists');

// load documents from Api for a Cluster
export const loadClusterDocumentsForLists = createAction(
  '[COP/Lists/Api] Load Cluster Documents From Api',
  props<{ layerDocuments: LayerDocumentUIdsSet; position: any; zoomToBounds?: {}; clusterId?: string, clusterData?: object }>()
);

// load documents from Api for layer ids
export const loadLayersDocumentsForLists = createAction('[COP/Lists/Api] Load Layers Documents From Api', props<{ layerUIds: string[] }>());

// load summary documents from Api for layer id and document ids
export const loadSummaryDocumentsForLists = createAction(
  '[COP/Lists/Api] Load Summary Documents From Api',
  props<{
    sectionUId?: string;
    layerUIds?: string[];
    summaryForStatus: MapLayerSummaryByStatus;
    userClick: boolean;
    summaryByStatus?: MapLayerSummaryByStatus[];
  }>()
);

export const transitionLayerDocumentsToWorkflowStep = createAction(
  '[COP/Lists/API] Transition Documents to Workflow Step',
  props<{ layerDocuments: LayerDocuments; statusName: string }>()
);

export const loadDocumentsFromApiIntoCards = createAction(
  '[COP/Lists] Load Documents From Api Into Cards',
  props<{ query: ListQuery; name?: string; colorCode?: string, searchTerm?: string }>()
);

export const loadLayerDocumentsIntoCards = createAction(
  '[COP/Lists] Load Layer Documents Into Cards',
    props<{ layerDocuments: LayerDocuments; listType: 'assets' | 'selection' | 'documents'; totalCount?: number; name?: string; colorCode?: string; clusterId?: string; }>()
);

export const hideTableShowCardsIfDataLoaded = createAction('[COP/Lists] Hide Table And Show Cards If Data Is Loaded');
export const showCardForLayer = createAction('[COP/Lists] Show Card For Layer', props<{ layer: Layer; reload?: boolean }>());
export const showCardForSummary = createAction('[COP/Lists] Show Card For Summary', props<{ summary: MapLayerSummaryByStatus }>());
export const setCardsForDisplayToStore = createAction('[COP/Lists/Store] Set Cards To Display', props<{ cards: Card[] }>());

export const setCardDataToStore = createAction('[COP/Lists/Store] Setup Card View Data', props<{ cardView: CardView }>());
export const showCardsToStore = createAction('[COP/Lists/Store] Show Cards');
export const hideCardsToStore = createAction('[COP/Lists/Store] Hide Cards');
export const showCards = createAction('[COP/Lists] Show Cards');
export const clearCardsToStore = createAction('[COP/Lists/Store] Clear Cards');
export const setCardVisibilityToStore = createAction('[COP/Lists/Store] Hide Card', props<{ isVisible: boolean }>());
export const hideDisplayCardToStore = createAction('[COP/Lists/Store] Hide Current Display Card');
export const setListQueryToStore = createAction('[COP/Lists/Store] Sets List Query', props<{ query: ListQuery }>());
export const setAssetsListQueryToStore = createAction('[COP/Lists/Store] Sets Assets List Query', props<{ query: ListQuery }>());
export const setSelectListQueryToStore = createAction('[COP/Lists/Store] Sets Select List Query', props<{ query: ListQuery }>());
export const setRelatedListQueryToStore = createAction('[COP/Lists/Store] Sets Related List Query', props<{ query: ListQuery }>());

export const setTableTypeToStore = createAction('[COP/Lists/Store] Sets Table Type', props<{ tableType: ListsTableType }>());

export const hideTableToStore = createAction('[COP/Lists/Store] Hide Table');
export const showTableToStore = createAction('[COP/Lists/Store] Show Table', props<{ tableType: ListsTableType }>());
export const showTable = createAction('[COP/Lists] Show Table');
export const showAssetsTableToStore = createAction('[COP/Lists/Store] Show Assets Table');
export const showRelatedTableToStore = createAction('[COP/Lists/Store] Show Related Table');
export const hideTableShowCardToStore = createAction(
  '[COP/Lists/Store] Hide Table and Show Card',
  props<{ showSelectedDocument: boolean }>()
);
export const toggleShowCardsOrTableForLayerClick = createAction(
  '[COP/Lists] Toggle Show Layer Data as Card or Table Click',
  props<{ layer: Layer; reload?: boolean }>()
);

export const updateFloorFilterValue = createAction(
  '[COP/Lists] Update Floor Filter Value',
  props<{ value: string }>()
);

export const reloadAndShowCards = createAction('[COP/Lists] Reload And Show Cards');

export const setLayerQueryDataUpdateTime = createAction('[COP/Lists] Set data update time for query', props<{ layerUId: string }>());

export const cancelCardView = createAction('[COP/Lists] Cancel Card View');

//
// Export Templates
//
export const loadExportTemplates = createAction('[COP/Lists] Get Export Templates', props<{ datasetUIds: string[] }>());
export const loadExportTemplatesCompleteToStore = createAction(
  '[COP/Lists/Store] Get Export Templates Complete',
  props<{ results: QueryResult<ExportTemplate> }>()
);
